import type { PutSubscriptionRequestBody } from '../schema-overrides';
export { PlanTypes, BillingIntervals, BillingProcess, LimitNames } from '../schema-overrides';
export type { PlanLimitsType, PutSubscriptionRequestBody } from '../schema-overrides';

export function bodySerializer(body: PutSubscriptionRequestBody): string {
  return JSON.stringify(body);
}
